import { BreakpointRangeName, withBreakpointRange, WithChildren } from '@optimus-web/core';
import { WithBreakpointRange } from './breakpointRange';

type BreakpointComponentsProps = {
    [breakpoints in BreakpointRangeName]?: React.ComponentType<WithChildren>;
};

interface DefaultComponentProps {
    Default: React.ComponentType<WithChildren>;
}

type Props = WithBreakpointRange & BreakpointComponentsProps & DefaultComponentProps & WithChildren;

const ResponsivePure = ({ breakpointRange, children, Default, ...breakpointComponents }: Props) => {
    const BreakpointComponent = breakpointRange ? breakpointComponents[breakpointRange.name] : null;
    const ChosenComponent = BreakpointComponent || Default;
    return <ChosenComponent>{children}</ChosenComponent>;
};

export const Responsive = withBreakpointRange(ResponsivePure);
